// extracted by mini-css-extract-plugin
module.exports = {"Picture":"styles_Picture__8fE6G","fadeIn":"styles_fadeIn__XBvH4","Picture--full":"styles_Picture--full__202TB"};